const { coreApi } = require('../utils/axios');

async function getPrescribers() {
  const response = await coreApi.get(`/chains?type=prescriber`);

  return {
    chains: response.data.data,
    pagination: response.data.pagination,
  };
}

async function getChain(id) {
  const response = await coreApi.get(`/chains/${id}`);

  return response.data.data;
}

async function resendTextInvites({ organisationId, type, customMessage }) {
  const queryParams = new URLSearchParams({
    type,
  });

  const queryString = queryParams.toString();
  const endpoint = [`/chains/${organisationId}/resend-text-invites`, queryString].filter(Boolean).join('?');

  const payload = {
    ...(customMessage && { custom_message: customMessage }),
  };
  const response = await coreApi.put(endpoint, payload);

  return response.data;
}

const chainsAPI = {
  getPrescribers,
  getChain,
  resendTextInvites,
};

export default chainsAPI;
